import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from 'react-router';
import { Box, Button, TextField, Dialog, DialogContent, IconButton, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const Search = () => {
    const query = useQuery();
    const history = useHistory();

    const [searchValue, setSearchValue] = useState(query.get("search") || "");
    const [open, setOpen] = useState(false);

    const { playingMode, category } = useParams();

    useEffect(() => {
        setOpen(true);
    }, []);

    const handleSubmit = (evt) => {
        evt.preventDefault();
        close();
    }

    const close = () => {
        setOpen(false);
        setTimeout(() => {
            history.replace(category ? `/${playingMode}/category/${category}/?search=${searchValue}` : `/${playingMode}/?search=${searchValue}`);
        }, 300);
    }

    const clear = () => {
        setSearchValue("");
    }

    return (
        <Dialog 
          open={open} 
          onClose={close} 
          fullWidth 
          maxWidth="xs" 
        >
            <DialogContent>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                >
                    <TextField
                        variant="outlined"
                        placeholder="Search..."
                        spellCheck={false}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                searchValue && (
                                    <InputAdornment position="end">
                                        <IconButton onClick={clear}>
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            ),
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Search
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

export default Search;
